import instance from '../axios';

export const uploadFrames = async (imageUpload, dir, id, date) => {
    var formData = new FormData(); 
    formData.set( 
        "myFile", 
        imageUpload, 
        imageUpload.name 
    ); 
    formData.append( 
        "targetDir", 
        dir           
    );
    formData.append( 
        "id", 
        id           
    );
    formData.append( 
        "date", 
        date           
    );
    const response = await instance.post(`frames/upload-frame`, formData);
    return response;
}

export const uploadNumberedFrame = async (imageUpload, dir, id, date) => {
    var formData = new FormData(); 
    formData.set( 
        "myFile", 
        imageUpload, 
        imageUpload.name 
    ); 
    formData.append( 
        "targetDir", 
        dir           
    );
    formData.append( 
        "id", 
        id           
    );
    formData.append( 
        "date", 
        date           
    );
    const response = await instance.post(`frames/upload-template`, formData);
    return response;
}

export const create = async (data) => {
    const response = await instance.post(`frames/create`, data)
    return response
}

export const update = async (data) => {
    const response = await instance.post(`frames/update`, data)
    return response
}

export const deleteFrame = async (data) => {
    const response = await instance.post(`frames/delete`, data)
    return response
}

export const getCategories = async () => {
    const response = await instance.get(`frames/get-categories`)
    return response.data
}

export const getAllFramesTable = async () => {
    const response = await instance.get(`frames/get-all-table`)
    return response.data
}

export const getAllFrames = async () => {
    const response = await instance.get(`frames/get-all`)
    return response.data
}

export const getFrameById = async (id) => {
    const response = await instance.get(`frames/get-by-id?id=${id}`)
    return response.data
}

export const createFrameAssignment = async (data) => {
    const response = await instance.post(`frames/create-frame-assignment`, data)
    return response
}

export const updateFrameAssignment = async (data) => {
    const response = await instance.post(`frames/update-frame-assignment`, data)
    return response
}

export const deleteFrameAssignment = async (id) => {
    const response = await instance.post(`frames/delete-frame-assignment?id=${id}`)
    return response
}

export const getFrameAssignment = async (id) => {
    const response = await instance.get(`frames/get-frame-assignment?id=${id}`)
    return response.data
}

export const getAllFrameAssignment = async () => {
    const response = await instance.get(`frames/get-all-frame-assignment`)
    return response.data
}
